'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.whenMounted = whenMounted;
exports.whenUnmounted = whenUnmounted;
exports.whenUpdated = whenUpdated;

var _ramda = require('ramda');

function whenMounted(oldModel, newModel, watchPath, callback) {
  var oldThing = oldModel.getIn(watchPath);
  var newThing = newModel.getIn(watchPath);

  if ((0, _ramda.isNil)(oldThing) && !(0, _ramda.isNil)(newThing)) {
    callback(newThing);
  }
}

function whenUnmounted(oldModel, newModel, watchPath, callback) {
  var oldThing = oldModel.getIn(watchPath);
  var newThing = newModel.getIn(watchPath);

  if (!(0, _ramda.isNil)(oldThing) && (0, _ramda.isNil)(newThing)) {
    callback(oldThing);
  }
}

function whenUpdated(oldModel, newModel, watchPath, callback) {
  var oldThing = oldModel.getIn(watchPath);
  var newThing = newModel.getIn(watchPath);

  if (!(0, _ramda.isNil)(oldThing) && !(0, _ramda.isNil)(newThing) && !(0, _ramda.equals)(oldThing, newThing)) {
    callback(oldThing, newThing);
  }
}